import React from 'react';
import {RegressionGraDescGPU} from 'prophesier/dist/wrapper/index-with-deps-react.js';

const data = [[3, 3, 3, 4, 6, 6, 7],[7, 4, 7, 8, 7, 5, 9]];
const learningrate = 0.0003;
const iterations = 100;
class RegressionGradDescGPU extends React.Component {
    constructor() {
        super();
        this._onresult = this._onresult.bind(this)
        this._onpredict = this._onpredict.bind(this)
    }
    componentDidMount() {
        this.setState({showcomponent: true})
    }
    _onresult(event) {
        const {m, b, iteration, sse} = event.detail;
        console.log(m, b, iteration, sse)
    }
    _onpredict(event) {
        const {y} = event.detail
        console.log(y)
    }
    render() {
        const {showcomponent} = this.state;
        return (
            <div>
                 {(showcomponent) && <RegressionGraDescGPU 
                xs={data[0]} 
                ys={data[1]}
                x={4}
                result={this._onresult} 
                predict={this._onpredict}
                learningrate={learningrate}
                batchsize={iterations} />}
            </div>
        );
    }
}

export default RegressionGradDescGPU;

export const textCode = `
import React from 'react';
import {RegressionGraDescGPU} from 'prophesier/dist/wrapper/index-with-deps-react.js';

const data = [[3, 3, 3, 4, 6, 6, 7],[7, 4, 7, 8, 7, 5, 9]];
const learningrate = 0.0003;
const iterations = 100;
class RegressionGradDescGPU extends React.Component {
    constructor() {
        super();
        this._onresult = this._onresult.bind(this)
        this._onpredict = this._onpredict.bind(this)
    }
    componentDidMount() {
        this.setState({showcomponent: true})
    }
    _onresult(event) {
        const {m, b, iteration, sse} = event.detail;
        console.log(m, b, iteration, sse)
    }
    _onpredict(event) {
        const {y} = event.detail
        console.log(y)
    }
    render() {
        return (
            <div>
                 {(showcomponent) && <RegressionGraDescGPU 
                xs={data[0]} 
                ys={data[1]}
                x={4}
                result={this._onresult} 
                predict={this._onpredict}
                learningrate={learningrate}
                batchsize={iterations} />}
            </div>
        );
    }
}

export default RegressionGradDescGPU;
`

export const src = `
const template = "<prophesier-regressiongradesc-gpu></prophesier-regressiongradesc-gpu>";
const data = [[3, 3, 3, 4, 6, 6, 7],[7, 4, 7, 8, 7, 5, 9]];
const learningrate = 0.0003;
const iterations = 100;

document.onreadystatechange = () => {
    if (document.readyState === "complete") {
        const sampleCode  = document.querySelector("._sampleDomElement");
        sampleCode.innerHTML = template;
        const element = document.querySelector("prophesier-regressiongradesc-gpu");

        element.addEventListener("result", (event) => {
            const {m, b, iteration, sse} = event.detail;
            const output = JSON.stringify(event.detail)
            const div = document.createElement("div")
            div.innerHTML = \`\${output}\`;
			sampleCode.appendChild(div)
        })
        element.data = data; 
        element.learningrate = learningrate;  
        element.iterations = iterations;
    }
}
`

export const textCodeJQ = `
const template = "<prophesier-regressiongradesc-gpu></prophesier-regressiongradesc-gpu>";
const data = [[3, 3, 3, 4, 6, 6, 7],[7, 4, 7, 8, 7, 5, 9]];
const learningrate = 0.0003;
const iterations = 100;

const element = $(template)
element.prop({
    data: data,
    learningrate: learningrate,
    iterations: iterations
})
$(document.body).append(element)
`


// WEBPACK FOOTER //
// ./src/samples/Regressiongraddescgpu.js